export const ISN_RESPONSE_STATUS = {
  OK: 'ok',
  ERROR: 'error'
};



// WEBPACK FOOTER //
// src/constants/isnResponse.js